/**
 * ESM shim over the VENDORED formula module.
 *
 * `formula.js` and `vectors.json` are copied BYTE-IDENTICAL from keepr-api
 * (`utils/formula/`) and must never be edited here — the lock-step test in
 * `__tests__/formula.vectors.test.js` drives the shared vectors and
 * byte-compares the files when the API checkout sits beside this repo. The
 * vendored file is CommonJS because the API runs it under Node; app code
 * imports from here and injects the web's units module wherever the API
 * would inject its own (`analyze(ast, { resolveRef, units })`,
 * `evaluate(ast, { …, units })`) — and the web's currency module beside it
 * (`{ units: formulaUnits, currency: formulaCurrency }`), which a money
 * formula cannot analyse, evaluate or print without.
 */
import formula from './formula';
import * as units from '../units';
import currency from '../currency';

export const {
	MAX_FORMULA_LENGTH,
	MAX_REFS,
	MAX_TEXT_LENGTH,
	MAX_WORK,
	FormulaError,
	tokenize,
	parse,
	serialize,
	references,
	scopedReferences,
	entryCallOf,
	isTimeDependent,
	describeElement,
	entriesOf,
	columnValuesOf,
	typeLabel,
	dataTypeOf,
	analyze,
	evaluate,
	toStored,
	renderText,
	describeFunctions,
	describeFunction,
	FUNCTION_NAMES,
} = formula;

/** The web's units module in the shape the formula module injects. */
export const formulaUnits = units;

/** The web's currency module (the vendored CommonJS object) in the shape the formula module injects. */
export const formulaCurrency = currency;

export default formula;
